import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { setupGlobalErrorReporting } from './lib/errorReporter'
import './index.css'
import './auth.css'
import './light-mode.css'
import './mobile.css'
import App from './App.tsx'

const sentryDsn = import.meta.env.VITE_SENTRY_DSN

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_APP_RELEASE,
    enabled: true,
    sendDefaultPii: false,
  })
}

// Sett opp global feillogging til GitHub Issues
setupGlobalErrorReporting()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
